/** Canonical toolbar chrome (freelancer design). Override per surface via `classNames`. */
export const searchFilterToolbarDefaultClassNames = {
  toolbarOuter: "flex flex-col md:flex-row",
  toolbarInner:
    "w-full flex justify-between md:gap-4 mt-8 md:mt-4 mb-8 md:mb-4 md:relative items-center flex-wrap gap-y-4",
  toolbarInnerWhenDesktopModalOpen:
    "bg-white border-2xl rounded-tl-3xl rounded-tr-3xl md:pt-4 md:pb-2 md:px-6",
  mobileFilterButton: "w-36 border border-secondary-light md:hidden",
  desktopFilterButton: "border border-secondary-light hidden md:flex",
  desktopFilterButtonHiddenWhenSortOpen: "invisible",
  mobileSortButton: "w-36 border border-secondary-light md:hidden",
  desktopSortButton: "border border-secondary-light hidden md:flex",
  desktopSortButtonHiddenWhenFilterOpen: "invisible",
  desktopFilterModal:
    "animate-fade-in border-2xl absolute right-0 top-16 z-40 flex w-full flex-col gap-2 rounded-bl-3xl rounded-br-3xl bg-white p-6 [box-shadow:0_44px_67px_rgba(0,0,0,0.25)]",
  desktopSortModal:
    "animate-fade-in border-2xl absolute right-0 top-16 z-40 flex w-full flex-col gap-2 rounded-bl-3xl rounded-br-3xl bg-white p-6 pt-2 [box-shadow:0_44px_67px_rgba(0,0,0,0.25)]",
  mobileFilterModal: "md:hidden",
  mobileSortModal: "md:hidden",
  mobileFilterButtonWhenOpen: "",
  mobileSortButtonWhenOpen: "",
  desktopFilterButtonWhenOpen: "",
  desktopSortButtonWhenOpen: "",
} as const;

/** Overrides accept any Tailwind string; defaults stay typed via `as const`. */
export type SearchFilterToolbarClassNamesOverride = {
  [K in keyof typeof searchFilterToolbarDefaultClassNames]?: string;
};
